import type { IconData } from '@stacksjs/iconify-core'

export const starCircleSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5m4.586 16.341l-2.81-5.418c-.747-1.439-2.805-1.439-3.551 0l-2.81 5.418l-5.96 1.174c-1.522.3-2.138 2.145-1.1 3.3l4.225 4.698l-.776 6.288c-.195 1.584 1.45 2.747 2.878 2.035L24 32.68l5.318 2.655c1.427.712 3.073-.451 2.878-2.035l-.776-6.288l4.225-4.699c1.038-1.154.422-3-1.1-3.3l-5.96-1.173Z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default starCircleSolid
